export default "__VITE_ASSET__BiwrVXnL__"